import { BookmarkMenu } from '@/common/bookmark/BookmarkMenu';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { useState } from 'react';
import { SideNavButton } from './SideNavButton';

export const BookmarkButton = () => {
  const [anchorEl, setAnchorEl] = useState(null);

  // When the BookmarkButton is clicked, set the anchor element
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  // Close the BookmarkMenu by clearing the anchor
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <SideNavButton onClick={handleClick} tooltip="Bookmarks" icon={fas.faBookmark} />
      <BookmarkMenu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose} />
    </>
  );
};
